<template>
  <f7-page name="error" no-toolbar v-bind:data-error-no="this.error_no">
    <f7-navbar class="white" v-bind:class="error_navbar_border">
      <f7-nav-left>
      </f7-nav-left>
      <f7-nav-title v-html="error_title"></f7-nav-title>
      <f7-nav-right>
        <span class="space4closeicon"/>
        <span class="space4closeicon"/>
       <f7-link class="external" @click="closeApp()">
          <img :src="addAssetsPublicPath('static/images/common/icon_close.svg')">
        </f7-link> 
      </f7-nav-right>
    </f7-navbar>

    <f7-block class="icon">
      <img v-if="error_btn_close" :src="addAssetsPublicPath('static/images/common/icon_maintance.svg')" alt="">
      <img v-else :src="addAssetsPublicPath('static/images/common/halfsheet/icon_error.svg')" alt="">
    </f7-block>
    <f7-block class="text1"><p v-html="tit"></p></f7-block>
    <f7-block class="text2"><p v-html="msg"></p></f7-block>
    <f7-block class="btns">
      <f7-button fill                       data-target=".sheet-modal-error" sheet-close v-if="error_btn_ok"    >OK</f7-button>
      <f7-button class="button-white"       data-target=".sheet-modal-error" sheet-close v-if="error_btn_cancel">キャンセル</f7-button>
      <f7-button fill class="button_close external" @click="noticeOpen()" data-target=".sheet-modal-error" sheet-close v-if="error_btn_close">お知らせを開く</f7-button>
    </f7-block>
    <f7-block class="text3">
      <p v-html="error_msg3"></p>
    </f7-block>

  </f7-page>
</template>
<script>
  import { addAssetsPublicPath } from '@/utils/env.js';

  export default {
    data() {
      this.error_no='1';
      this.$root.ini();
      // console.log(this.$root.errData);
      return this.iniError(this.$root.errData||{_ekey:'maintenance'});
    },
    methods: {
      iniError(err, rtn={}){
          
          rtn.error_msg3=''; 
          rtn.error_title='';
          rtn.error_btn_cancel=false;
          rtn.error_btn_ok=false;
          rtn.error_btn_close=false;
          rtn.error_navbar_border='no_border';
        if(err._ekey==='timeout'){
          rtn.tit = 'タイムアウトしました';
          rtn.msg = '右上の「×」ボタンを押して<br>再度PayPayホーム画面から<br>ポイント運用をタップしてください';
        }
        else if(err._ekey==='maintenance'){
          //rtn.tit = 'メンテナンス中';
          //rtn.msg = err._emsg || '申し訳ございません。<br>ただいま「ポイント運用」が<br>メンテナンス中のため、ご利用いただけません。';
          this.error_no = '6';
          rtn.tit = 'メンテナンス中';
          rtn.msg = 'ただいまメンテナンス中のため<br>ご利用いただけません<br>ご迷惑をおかけして申し訳ありません<br><br><br><span style="color: #242323;">PPSCインベストメントサービスの<br>お知らせをご確認ください</span>'
          rtn.error_msg3='ポイント運用はPPSCインベストメントサービスが<br>提供するサービスです'; 
          rtn.error_title='ポイント運用';
          rtn.error_btn_cancel=false;
          rtn.error_btn_ok=false;
          rtn.error_btn_close=true;
          rtn.error_navbar_border='border-bottom';
          this.$root.set('sessBack', this.sessBack);
        }
        else if(err._ekey==='business'){  // 全画面のエラー画面にビジネスエラーは基本ないはず
          rtn.tit = '入力内容をご確認ください。<br>追加または引き出し（交換）は完了していません。';
          rtn.msg = err._emsg || '入力内容をご確認ください。<br>追加または引き出し（交換）は完了していません。';
        }
        else if(err._ekey==='invalid_csrf_token'){// csrf token　チェックエラー
          this.tit = 'エラーが発生しました';
          this.msg = err && err._emsg || 'ポイント運用ミニアプリからアクセスしてください。';
        }
        else if(err._ekey==='invalid_allperiod'){// allperiod　全期間エラー
          this.tit = 'エラーが発生しました';
          this.msg = err && err._emsg || '一度ポイント運用を閉じてから再度お試しください。';
        }
        //お知らせタイムアウトエラー画面
        else if(err._ekey === "noticetimeout"){
          rtn.tit = 'エラーが発生しました';
          rtn.msg = err._emsg || 'しばらく時間をおいてから<br>再度お試しください';
        } 
        else if(err._ekey === "outof_tradetime"){
          this.tit = '注文受付時間外のため<br>処理を完了できません';
          this.msg = err && err._emsg || '受付時間内に再度お試しください';
        }
        else {
          rtn.tit = '通信エラーが発生しました。<br>時間をおいて再度お試しください。';
          // this.msg = err._emsg || '通信状態が不安定のようです。インターネット接続状態を確認した上で再度お試しください';
          rtn.msg = err._emsg || '右上の「×」ボタンを押して、<br>再度PayPayホーム画面から<br>ポイント運用をタップしてください。';
        }
        g.hideLoading();
        rtn.btn = err.btn===undefined ? 1 : err.btn;
        return rtn;
      },
      sessBack(res) {
        if(res._ekey) return;
        this.$root.set('sessBack', null);
        this.iniError({_ekey:'timeout',btn:0}, this);
      },
      closeApp() {
        APIPP.closeApp()
      },
      addAssetsPublicPath,
      noticeOpen() {
        APIPP.dpExBrowerByUrlClose(g._externalLinks.ppscMaintenance)
      }
    },
  };
</script>
